import numeral from "numeral";
export const calculateLVR = (epv, ba) => {
	if (epv < 100000 || epv > 2500000 || ba < 80000 || ba > 2000000 || ba > epv || epv === undefined || ba === undefined) {
		return "- -%";
	} else
		return numeral(ba)
			.divide(epv)
			.format("0%");
};
